import React from "react";
import Seo from "@/utils/seo";
import Head from "next/head";
import Banner from "@/components/pages/services/banner";
import ServicesGrid from "@/components/pages/services/services-grid";
import { getJsonLd } from "@/utils/get-jsonld";
export default function Services() {
  const seo = {
    slug: "/our-services",
  };

  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getJsonLd({ slug: "our-services" })),
          }}
        />
      </Head>
      <Banner />
      <ServicesGrid />
    </>
  );
}
